/* eslint-disable */
import {http} from '@/helpers/http';
import {transformDateView} from "@/helpers/transformDates";

const defaultDistrict = {
    id: 'new',
    updated_at: '',
    name: '',
    alias: '',
};

const stringToNumber = (obj) => {
    return Object.keys(obj).reduce((newObject, key) => {
        return {...newObject, [key]: Number(obj[key])};
    }, {});
};

export default {
    namespaced: true,
    state() {
        return {
            list: [],
            search: '',
            current: defaultDistrict,
        };
    },

    mutations: {
        /* Записать новый список */
        setList(state, data) {
            state.list = data.slice();
        },

        /* Установить поисковое слово */
        setSearch(state, data) {
            state.search = data;
        },

        /* Установить свойство текущего объекта */
        setValue(state, payload) {
            state.current = {
                ...state.current,
                ...payload
            };
        },

        /* Очистить текущее значение */
        clearCurrent(state) {
            state.current = {
                ...state.current,
                ...defaultDigital
            }
        },

        /* Удалить из списка */
        removeFormList(state) {
            const index = state.list.findIndex(({id}) => id === state.current.id);
            state.list.splice(index, 1);
        },

        /* Установить текущий объект по идентификатору */
        setCurrent(state, _id) {
            const promo = state.list.find(({id}) => id === _id)
            state.current = {
                ...state.current,
                ...promo
            }
        },

        /* Заменить по идентификатору */
        replaceById(state, current) {
            const index = state.list.findIndex(({id}) => id === current.id);
            state.list.splice(index, 1, current);
        },

        /* Добавить в список */
        addList(state, current) {
            state.list.push({...current, id: state.list.length + 1});
        }
    },

    getters: {
        // getList: state => state.list.filter(({ title }) => title.indexOf(state.search) >= 0),

        getList: state => state.list
            .filter(({name}) => {
                    return name.toLowerCase().indexOf(state.search.toLowerCase()) >= 0;
                }
            )
            .map(({id, alias, name, updated_at, updated_at_formatted}) => {
                return {
                    id,
                    name,
                    alias,
                    updated_at: updated_at_formatted
                };
            }),

        getItems: state => state.list.map(({id, name}) => {
            return {id, name};
        }),

        getById: state => _id => state.list.find(({id}) => id === _id),

        getCurrent: state => state.current,

        getFormatList: (state, getters) => {
            return getters.getList.map(obj => ({
                ...obj,
                activity: obj.activity ? 'Да' : 'Нет'
            }))
        }
    },

    actions: {
        async getList({commit}) {
            try {
                const {data} = await http.get('/admin/districts');
                commit('setList', data);
                console.log('cases getList', data)
            } catch (e) {
                throw e;
            }
        },

        async remove({commit}, id) {
            await http.delete('/admin/districts/' + id);
            commit('clearCurrent');
        },

        async getById({commit, rootState, state}, id) {
            if (id === null || id === 'new') {
                commit('clearCurrent');
                return;
            }

            const {data} = await http.get('/admin/districts/' + id);

            commit('setValue', {
                id: data.id,
                name: data.name,
                alias: data.alias,
            });
        },


        async save({state}) {
            // Это новый элемент или редактирование?
            const isNew = state.current.id === 'new' || state.current.id === null;

            if (!isNew) {
                const {data: id} = await http.put('/admin/districts/' + state.current.id, {
                    name: state.current.name,
                    alias: state.current.alias,
                });
                return id.id;
            } else {
                const {data: id} = await http.post('/admin/districts', {
                    name: state.current.name,
                    alias: state.current.alias,
                });
                return id.id;

            }

        }
    },
};
